import { render } from "./CustomAudienceManagement.vue?vue&type=template&id=164847c2&scoped=true"
import script from "./CustomAudienceManagement.vue?vue&type=script&lang=js"
export * from "./CustomAudienceManagement.vue?vue&type=script&lang=js"

import "./CustomAudienceManagement.vue?vue&type=style&index=0&id=164847c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164847c2"]])

export default __exports__